<!-- Display the message for MOTO -->
<ng-content select="ap-ogone-message,ap-callout"></ng-content>
<!-- the div the messgae would be displayed -->
<div id="div-hosted-tokenization"></div>
<!-- The button to validate the ogon form -->
<button class="btn btn-success" (click)="submitForm()" type="submit" attr.aria-label="{{'SUPPORT.OGONE.SEND' | translate}}">{{'SUPPORT.OGONE.SEND' | translate}}</button>
